import {
	GET_VERIFY_APPROVE_APPEAL_LETTER_USER_LIST,
	GET_VERIFY_APPROVE_APPEAL_LETTER_USER_LIST_SUCCESS,
	GET_VERIFY_APPROVE_APPEAL_LETTER_USER_LIST_FAIL,
	GET_VERIFY_APPROVE_APPEAL_LETTER_USER_LIST_RESET,
} from '../actions/getVerifyApproveAppealLetterUserListAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getVerifyApproveAppealLetterUserListReducer = (
	state = initialState,
	action,
) => {
	switch (action.type) {
		case GET_VERIFY_APPROVE_APPEAL_LETTER_USER_LIST:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_VERIFY_APPROVE_APPEAL_LETTER_USER_LIST_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_VERIFY_APPROVE_APPEAL_LETTER_USER_LIST_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_VERIFY_APPROVE_APPEAL_LETTER_USER_LIST_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getVerifyApproveAppealLetterUserListReducer;
